import { getAuthHeaders } from '../../../actions/authActions';
import tempMeeApi from '../../../apis/tempMee';

/**
 * Fetches child offices by parent office ID from the API
 *
 * @param {string} officeId - Parent office ID
 * @returns {Promise<import('../types/User.api').IGetChildOfficesApiResponse>} Child offices API response
 */
export const getChildOffices = async (officeId) => {
  const headers = await getAuthHeaders();

  const response = await tempMeeApi.get(`/admin/${officeId}/descend`, {
    headers,
  });

  return response.data;
};
